import { TenantStatusEnum } from '../../tenants/enums/tenant-status.enum';
import { MeteringObservedState } from '../types/metering-observed-state.type';

/**
 * Metering provider state row returned by observe/apply lease SPs.
 * Bearer service surface — no @CaslSubject.
 */
export class MeteringProviderStateDto {
  id!: number;
  /** Numeric `tenants.id`. */
  tenantId!: number;
  /** Lowered internal org id (`tenants.tenantId`). */
  tenantOrgId!: string;
  /** Issued auth-provider org id — pass this to feature-flag / flag-target APIs. */
  tenantAuthProviderOrgId!: string;
  meteringProviderCustomerId!: string;
  observedHash?: string | null;
  appliedHash?: string | null;
  observedState?: MeteringObservedState | null;
  observedAt?: string | null;
  dirtyAt?: string | null;
  driftCheckedAt?: string | null;
  consecutiveIncompleteReads!: number;
  /**
   * From `tenant_billing` on the observe/apply lease result. Start of the
   * trial window.
   */
  trialStartsAt?: string | null;
  /**
   * From `tenant_billing` on the observe/apply lease result. Instant capture
   * may emit (trial end when `trialStartsAt` is set).
   */
  meteringStartsAt?: string | null;
  tenantStatus?: TenantStatusEnum | null;
}
